var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about mt-5"},[_c('h1',[_vm._v("Haloo Admin")]),_c('h4',[_vm._v("Please login as admin to manage your data products")])])}]

export { render, staticRenderFns }